<template>
  <div class="page">
    <div class="login-wrapper">
      <div class="login-content">
        <div class="site-logo">
          <img src="../assets/images/logo-trans.png" />
        </div>
        <div class="site-text">
          <div class="main">精进卓越&nbsp;&nbsp;赋能增长</div>
          <div class="sub">欢迎使用百威中国售点物料一站式服务平台</div>
        </div>
        <div class="site-login">
          <el-tabs class="site-login-tab" v-model="loginMethod" stretch>
            <el-tab-pane label="账号密码登录" name="other-login">
              <el-form ref="loginForm" :model="loginForm" :rules="loginRules">
                <el-form-item prop="loginAccount">
                  <el-input placeholder="用户名" v-model="loginForm.loginAccount" @keyup.enter.native="login" />
                </el-form-item>
                <el-form-item v-show="!passwordShow" class="site-login-password" prop="password">
                  <el-input placeholder="密码" v-model="loginForm.password" type="password" @keyup.enter.native="login" />
                  <img src="../assets/images/password-show.png" @click="handlePassword" />
                </el-form-item>
                <el-form-item v-show="passwordShow" class="site-login-password" prop="password">
                  <el-input placeholder="密码" v-model="loginForm.password" type="text" @keyup.enter.native="login" />
                  <img src="../assets/images/password-hidden.png" @click="handlePassword" />
                </el-form-item>
              </el-form>
              <el-button class="login-btn cursor" :loading="loading" @click="login">登录 Login</el-button>
            </el-tab-pane>
            <el-tab-pane label="百威员工登录" name="ab-login">
              <div class="login-sso">
                <div>即将开放</div>
                <!-- <el-button class="login-btn cursor" :loading="loading" @click="ABInBevLogin">登录 Login</el-button> -->
              </div>
            </el-tab-pane>
          </el-tabs>

          <!-- <div class="login-text cursor">登录遇到问题？</div> -->
          <!-- <div class="login-sso">
            <router-link :to="{ name: 'sso-sign-in' }">使用百威员工账号登录</router-link>
          </div> -->
        </div>
      </div>
    </div>

    <ResetPassword ref="reset-password" :loginAccount="loginForm.loginAccount" />

    <Footer :show-help="false"/>
  </div>
</template>

<script>
import Footer from './layout/components/footer'
import ResetPassword from '../components/reset-password'
import authApi from '@/api/auth'
import { cryptoUtils } from '../utils/common'
import { validateURL } from '@/utils/validate'
import { commonUtils } from '@/utils/common'
export default {
  name: 'login',
  components: {
    Footer,
    ResetPassword
  },
  data () {
    return {
      loginForm: {
        loginAccount: '',
        password: ''
      },
      loginRules: {
        loginAccount: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      loading: false,
      loginMethod: 'other-login',
      passwordShow: false
    }
  },
  mounted() {
    authApi.getCode()
  },
  methods: {
    login () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.loginForm.password = this.loginForm.password.trim()
          const loginForm = {
            loginAccount: this.loginForm.loginAccount,
            password: cryptoUtils.AESEncrypt(this.loginForm.password)
          }
          authApi.login(loginForm).then(response => {
            this.loading = false
            const { resultCode, resultData, resultMsg } = response.data
            if (resultCode === '0') {
              this.$store.commit('SET_USER_INFO', resultData)
              this.$store.commit('setLoginFrom', true)

              const { finalSysBizRoleList} = response.data.resultData.clientInfo
              let roleList = finalSysBizRoleList.map(role => role.roleCode)
              let isBccProduct = roleList.includes('bcc_vendor_manage') 
              let isAdmin = roleList.includes('super_admin') || roleList.includes('common_admin')

              // 跳转
              if (validateURL(this.$route.query.redirectTo)) {
                const redirectUrl = new URL(decodeURIComponent(this.$route.query.redirectTo))
                const isIcircleUrl = redirectUrl.origin === this.getIcircleUrl()
                if (isIcircleUrl && redirectUrl.pathname === '/order/info' ) {
                  // 直接跳转到渠道项目订单
                  const redirectTo = redirectUrl.pathname + (redirectUrl.search || '') || '/material/index'
                  commonUtils.handleIcircle(encodeURIComponent(redirectTo))
                  return
                }
              }

              let targetUri = ''
              if (isBccProduct) {
                targetUri = '/pocm-home'
              } else if (isAdmin){
                targetUri = '/finance/home'
              } else {
                targetUri = this.$store.state.user.targetUri ? this.$store.state.user.targetUri : '/home'
              }
              localStorage.setItem('pocmTargetUri', targetUri)
              commonUtils.handleIcircle(targetUri)

              // const targetUri = this.$store.state.user.targetUri ? this.$store.state.user.targetUri : '/home'
              // this.$router.push(targetUri)
               
            } else if (resultCode === '210908') {
              this.$alert(resultMsg, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  if (action === 'confirm') {
                    this.$refs['reset-password'].show()
                  }
                }
              })
            } else if (resultCode === 'BeesForceNotVerified') {
              this.$alert(
                '<div>当前登录账号未完成身份认证</div><div>区域销售请前往尊享先锋执行工具小程序登录后完成验证绑定</div><div>非销售用户请发送邮件至apac.icircle@budweiserapac.com服务邮箱维护信息后重新尝试登录</div>',
                '提示', {
                  dangerouslyUseHTMLString: true,
                  type: 'warning',
                  customClass: 'login-error-box'
                }
              )
            } else {
              this.$message.error(resultMsg)
            }
          }).catch(() => {
            this.loading = false
          })
        }
      })
    },
    ABInBevLogin () {
      this.$router.push({ name: 'sso-sign-in' })
    },

    handlePassword () {
      this.passwordShow = !this.passwordShow
    },
    getIcircleUrl () {
      const inUse = ['prod', 'test', 'dev'].includes(process.env.VUE_APP_ENV)
      if (!inUse) {
        return this.$notify({
          title: '提示',
          message: '暂未开放，敬请期待',
          type: 'warning'
        })
      }
      const urlMap = {
        dev: 'https://icircle-dev.abipocm.com',
        test: 'https://icircle-test.abipocm.com',
        prod: 'https://icircle.abipocm.com'
      }
      return urlMap[process.env.VUE_APP_ENV]
    }
  },

  beforeRouteLeave (to, from, next) {
    this.$store.commit('setTargetUri', '')
    next()
  },
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
}
.login-wrapper {
  height: calc(100% - 100px);
  width: 100%;
  color: $base-white;
  box-sizing: border-box;
  background: url("../assets/images/login-bg.jpg") center no-repeat;
  background-size: cover;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  .site-logo {
    width: 290px;
    height: 84px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .site-text {
    margin: 50px 0 60px 0;
    .main {
      font-weight: 700;
      font-size: 50px;
      margin-bottom: 15px;
    }
    .sub {
      font-size: 18px;
    }
  }
  .login-btn {
    width: 300px;
    height: 50px;
    line-height: 50px;
    color: $base-red;
    background-color: $base-white;
    margin: 30px auto 15px auto;
    border-radius: 30px;
    font-size: $font-20;
    border: 0;
    padding: 0;
    &:hover {
      background-color: $base-red;
      color: $base-white;
    }
  }
  .login-text {
    font-size: $font-12;
  }
  .site-login {
    width: 330px;
    margin: auto;
    .el-input {
      width: 330px;
      display: block;
      margin: auto;
    }

    .site-login-password {
      position: relative;
      img {
        width: 22px;
        height: 22px;
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
      }
    }
  }
  .login-sso {
    padding-top: 30px;
    font-size: 18px;
  }
}
</style>
